import * as React from "react"
export const Svg_041 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={59}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M0 44.286A6.943 6.943 0 0 0 6.935 51.2h16.227v-6.914H0Z"
    />
    <path
      fill="url(#b)"
      d="M35.838 51.2h16.227c3.817 0 6.924-3.1 6.935-6.914H35.838V51.2Z"
    />
    <path fill="url(#c)" d="M3.457 7.8h52.086v4.61H3.457V7.8Z" />
    <path fill="url(#d)" d="M26.62 44.286h5.76V51.2h-5.76v-6.914Z" />
    <path
      fill="url(#e)"
      d="M55.543 15.867H3.457v24.961h52.086V15.867Zm-36.63 17.666h-3.457v-3.457h3.457v3.457Zm0-6.914h-3.457v-3.457h3.457v3.457Zm24.63 6.914H22.37v-3.457h21.174v3.457Zm0-6.914H22.37v-3.457h21.174v3.457Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={5.356}
        x2={6.666}
        y1={45.323}
        y2={52.426}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={41.194}
        x2={42.504}
        y1={45.323}
        y2={52.426}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={15.502}
        x2={15.769}
        y1={8.492}
        y2={13.373}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={27.951}
        x2={31.465}
        y1={45.323}
        y2={50.062}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={15.502}
        x2={22.721}
        y1={19.611}
        y2={43.989}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)